module.exports = __webpack_public_path__ + "img/elaterna_logo_web_beta.a212dab7.svg";